module.exports = require('./src/js/JSONEditor');



//////////////////
// WEBPACK FOOTER
// E:/Projects/Felixin/Projects/EddyNow/eddy-admin/node_modules/jsoneditor/index.js
// module id = eR70
// module chunks = 0